import React from "react";
import { Container, makeStyles } from "@material-ui/core";
import ReceiptIcon from "@material-ui/icons/Receipt";

import Page from "src/components/Page";
import PageHeader from "src/views/components/PageHeader";
import View from "./View";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },
}));

const Index = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Invoice">
      {/*
        maxWidth={false}, not "lg".

        The invoice table has ten columns and a minWidth of 650, plus
        Preview and Send buttons in the last one. Inside a 1280px "lg"
        container it scrolls sideways on most laptops. This page is a
        wide data table, so let it use the screen.
      */}
      <Container maxWidth={false}>
        <PageHeader
          icon={<ReceiptIcon />}
          title="Invoice"
          subtitle="View and manage invoices"
        />

        {/*
          No wrapper Box here. PageHeader already ends with
          marginBottom: theme.spacing(4); adding marginTop: spacing(3)
          on top of that stacks two gaps into one oversized one.
        */}
        <View />
      </Container>
    </Page>
  );
};

export default Index;
